import { files, businessesRef } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}business/all/available`
    );
    let businessList = [];
    let keywordToBusinessID = {};
    let servicesList = [];
    response.data.forEach((business) => {
      let businessData = business;
      if (businessData.services) {
        businessData.services = businessData.services.sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
      }
      if (business.id != "32" && business.status == "Approved & Live") {
        servicesList = servicesList.concat(businessData.services);
        servicesList = servicesList.concat(businessData.searchServices);
        businessList.push({ id: business.id, ...businessData });
        keywordToBusinessID[businessData.urlKeyword] = business.id;
      } else {
        businessList.push({ id: business.id, ...businessData });
        keywordToBusinessID[businessData.urlKeyword] = business.id;
      }
    });
    commit(
      "setServices",
      servicesList.unique().sort((a, b) => (a > b ? 1 : -1))
    );

    commit("setBusinessList", businessList);
    commit("setKeywordToBusinessID", keywordToBusinessID);
  },
  loadAllAdmin: async ({ commit, rootState }) => {
    const response = await axios.get(`${rootState.axios.API}business/all`, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    let businessList = [];
    let keywordToBusinessID = {};
    response.data.forEach((business) => {
      let businessData = business;
      if (businessData.services) {
        businessData.services = businessData.services.sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
      }
      businessList.push({ id: business.id, ...businessData });
      keywordToBusinessID[businessData.urlKeyword] = business.id;
    });

    commit("setBusinessList", businessList);
    commit("setKeywordToBusinessID", keywordToBusinessID);
  },
  loadProfile: async ({ commit, state, rootState }, id) => {
    let business = {};
    // TODO: Get this to not need a Try Catch
    try {
      const response = await axios.get(`${rootState.axios.API}business/${id}`, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      });
      business = response.data[0];
    } catch (error) {
      const response = await axios.get(`${rootState.axios.API}business/${id}`);
      business = response.data[0];
    }

    commit("setCurrentProfile", business);
  },
  loadProfileByKeyword: async ({ commit, state, rootState }, keyword) => {
    let business = {};

    const response = await axios.get(
      `${rootState.axios.API}business/keyword/${keyword}`
    );
    response.data.forEach((businessData) => {
      business = { id: businessData.id, ...businessData };
    });

    commit("setCurrentProfile", business);
  },
  loadSalesEnquiries: async ({ commit, state, rootState }, keyword) => {
    const response = await axios.get(
      `${rootState.axios.API}business/salesEnquiry`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    let salesEnquiries = response.data;
    commit("setSalesEnquiries", salesEnquiries);
  },
  salesEnquirySave: async ({ commit, state, rootState, dispatch }, payload) => {
    await axios.put(`${rootState.axios.API}business/salesEnquiry`, payload, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    Vue.notify({
      type: "success",
      duration: 3000,
      title: "Save Successful",
      text: "Sales Enquiry has successfully been saved",
    });
    dispatch("loadSalesEnquiries");
  },
  salesEnquirySaveNoReload: async (
    { commit, state, rootState, dispatch },
    payload
  ) => {
    await axios.put(`${rootState.axios.API}business/salesEnquiry`, payload, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    Vue.notify({
      type: "success",
      duration: 3000,
      title: "Save Successful",
      text: "Sales Enquiry has successfully been saved",
    });
  },
  deleteSalesEnquiry: async ({ rootState, dispatch }, id) => {
    await axios.put(
      `${rootState.axios.API}business/salesEnquiry/delete/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    dispatch("loadSalesEnquiries");
  },
  salesEnquiryAdd: async ({ commit, state, rootState, dispatch }, payload) => {
    let salesEnquiry = await axios.post(
      `${rootState.axios.API}business/salesEnquiry`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    Vue.notify({
      type: "success",
      duration: 3000,
      title: "Creation Successful",
      text: "Sales Enquiry has successfully been created",
    });
    dispatch("loadSalesEnquiries");
    return salesEnquiry.data;
  },
  salesEnquiryDuplicate: async (
    { commit, state, rootState, dispatch },
    payload
  ) => {
    let salesEnquiry = await axios.post(
      `${rootState.axios.API}business/salesEnquiry/duplicate`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    Vue.notify({
      type: "success",
      duration: 3000,
      title: "Creation Successful",
      text: "Sales Enquiry has successfully been duplicated",
    });
    dispatch("loadSalesEnquiries");
    return salesEnquiry.data;
  },
  loadSpecificSalesEnquiry: async ({ commit, state, rootState }, id) => {
    let enquiry = {};
    // TODO: Get this to not need a Try Catch
    try {
      const response = await axios.get(
        `${rootState.axios.API}business/salesEnquiry/${id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      enquiry = response.data[0];
    } catch (error) {
      const response = await axios.get(
        `${rootState.axios.API}business/salesEnquiry/${id}`
      );
      enquiry = response.data[0];
    }

    commit("setSalesEnquiryCurrentProfile", enquiry);
  },
  sendIntroduction: async ({ rootState }, payload) => {
    await axios.post(
      `${rootState.axios.API}business/sendIntroduction`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  filter: async ({ commit, state, rootState }, filter) => {
    commit("setFilteredBusinesses", []);
    let businessList = [];
    businessList = state.list.filter((business) => {
      let serviceFound = false;
      let categoryFound = false;
      let subCategoryFound = false;
      let nameMatchFound = false;
      let regionMatch = false;
      let districtMatch = false;
      let siteTypeSearch = false;


      // Service and Name Match Search
      if (filter.service && filter.searchBy == 0) {
        let allServices = state.services.map((s) => s.toLowerCase());
        let searchedService = filter.service.toLowerCase();
        let businessServices = business.services
          ? business.services.map((s) => s.toLowerCase())
          : [];
        let businessSearchServices = business.searchServices
          ? business.searchServices.map((s) => s.toLowerCase())
          : [];

        if (allServices.includes(searchedService)) {
          serviceFound =
            businessServices.includes(searchedService) ||
            businessSearchServices.includes(searchedService);
        } else {
          serviceFound =
            businessServices.indexOf(searchedService) !== -1 ||
            businessSearchServices.indexOf(searchedService) !== -1;

          nameMatchFound =
            business.listTitle.toLowerCase().indexOf(searchedService) !== -1 ||
            business.name.toLowerCase().indexOf(searchedService) !== -1;
        }
      } else {
        serviceFound = true;
        nameMatchFound = true;
      }

      // Categories Search
      if (filter.category != "0" && filter.searchBy == 1) {
        categoryFound = business.category.includes(filter.category);
      } else {
        categoryFound = true;
      }

      // Sub Categories Search
      if (
        filter.subCategory.length > 0 &&
        filter.searchBy == 1 &&
        categoryFound
      ) {
        let subCategories = business.subCategory.split(",");
        if (
          filter.subCategory.some((subCat) => subCategories.includes(subCat))
        ) {
          subCategoryFound = true;
        }
      } else {
        subCategoryFound = true;
      }

      // Region Search
      if (filter.serviceRegions != "All Locations") {
        if (
          business.serviceRegions.includes(filter.serviceRegions)
        ) {
          regionMatch = true;
        }
      } else {
        regionMatch = true;
      }

      // District Search
      if (
        filter.serviceDistricts != "" &&
        !filter.serviceDistricts.includes("All Districts") &&
        !business.serviceRegions.includes("Nationwide")
      ) {
        if (
          filter.serviceDistricts.some((district) =>
            business.serviceDistricts.includes(district)
          )
        ) {
          districtMatch = true;
        }
      } else {
        districtMatch = true;
      }

      // Site Type Search
      if (filter.showAll) {
        siteTypeSearch = true;
      } else if (filter.showCommercial && business.showCommercial == "1") {
        siteTypeSearch = true;
      } else if (filter.showConsumer && business.showConsumer == "1") {
        siteTypeSearch = true;
      }

      return (
        (serviceFound || nameMatchFound) &&
        business.status === "Approved & Live" &&
        business.id != "32" &&
        districtMatch &&
        regionMatch &&
        categoryFound &&
        subCategoryFound &&
        siteTypeSearch
      );

    });


    //SORTING LIST BY search weight depending on filter
    //if search weight has the same value then sort alphabetically
    //this code needs to improve
    if (filter.showCommercial) {
      businessList.sort((a, b) => {
        if (parseInt(a.commercialSearchWeight) < parseInt(b.commercialSearchWeight)) {
          return 1;
        }
        if (parseInt(a.commercialSearchWeight) > parseInt(b.commercialSearchWeight)) {
          return -1;
        }
        if (parseInt(a.commercialSearchWeight) == parseInt(b.commercialSearchWeight)) {
          if (a.listTitle.toUpperCase() < b.listTitle.toUpperCase()) {
            return -1
          }
          if (a.listTitle.toUpperCase() > b.listTitle.toUpperCase()) {
            return 1
          }
          return 0
        }
      });
    } else if (filter.showConsumer) {
      businessList.sort((a, b) => {
        if (parseInt(a.consumerSearchWeight) < parseInt(b.consumerSearchWeight)) {
          return 1;
        }
        if (parseInt(a.consumerSearchWeight) > parseInt(b.consumerSearchWeight)) {
          return -1;
        }
        if (parseInt(a.consumerSearchWeight) == parseInt(b.consumerSearchWeight)) {
          if (a.listTitle.toUpperCase() < b.listTitle.toUpperCase()) {
            return -1
          }
          if (a.listTitle.toUpperCase() > b.listTitle.toUpperCase()) {
            return 1
          }
          return 0
        }
      });
    } else if (filter.showAll) {
      businessList.sort((a, b) => {
        if (parseInt(a.searchWeight) < parseInt(b.searchWeight)) {
          return 1;
        }
        if (parseInt(a.searchWeight) > parseInt(b.searchWeight)) {
          return -1;
        }
        if (parseInt(a.searchWeight) == parseInt(b.searchWeight)) {
          if (a.listTitle.toUpperCase() < b.listTitle.toUpperCase()) {
            return -1
          }
          if (a.listTitle.toUpperCase() > b.listTitle.toUpperCase()) {
            return 1
          }
          return 0
        }
      });

    }
    // console.log(businessList)
    commit("setFilteredBusinesses", businessList);
  },
  delete: async ({ commit, rootState, dispatch }, businessId) => {
    let updateBusiness = await axios.post(
      `${rootState.axios.API}business/delete`,
      {
        id: businessId,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    dispatch("loadAllAdmin");
  },
  deleteOurWork: async ({ commit, rootState }, ID) => {
    let updateBusiness = await axios.post(
      `${rootState.axios.API}businessOurWork/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  deleteLearnMore: async ({ commit, rootState }, ID) => {
    let updateBusiness = await axios.post(
      `${rootState.axios.API}businessLearnMore/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  deleteTestimonial: async ({ commit, rootState }, ID) => {
    let updateBusiness = await axios.post(
      `${rootState.axios.API}businessTestimonial/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  save: async ({ commit, rootState, dispatch }, business) => {
    if (business.id) {
      // Uploading Image
      if (business.image != undefined) {
        let uploadImageResult = await axios.post(
          `${rootState.axios.API}business/updateProfileImage`,
          {
            id: business.id,
            imageData: business.image.dataUrl,
          },
          {
            headers: {
              Authorization: `Bearer ${rootState.user.data.auth._lat}`,
            },
          }
        );
        delete business.image;
        if (uploadImageResult.data.Result == "Success") {
          business.imageUrl = uploadImageResult.data.objectUrl;
        }
      }
      business.firebase_id = null;

      await axios.post(`${rootState.axios.API}business/update`, business, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      });
      let response = await axios.get(
        `${rootState.axios.API}business/${business.id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      business = response.data[0];
      dispatch("loadAllAdmin");
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Save Successful",
        text: "Business has successfully been saved",
      });
      return { ...business };
    } else {
      let createBusiness = await axios.post(
        `${rootState.axios.API}business/create`,
        business,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Creation Successful",
        text: "Business has successfully been created",
      });
      let business_id = createBusiness.data.businessID;
      let response = await axios.get(
        `${rootState.axios.API}business/${business_id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      business = response.data[0];
      dispatch("loadAllAdmin");
      return { ...business };
    }
  },
  createTestimonial: async ({ rootState }, payload) => {
    try {
      await axios.post(
        `${rootState.axios.API}business/createTestimonial`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
    } catch (error) {
      await axios.post(
        `${rootState.axios.API}business/createTestimonial`,
        payload
      );
    }
    return "success";
  },
  loadTestimonial: async ({ commit, state, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}businessTestimonial/all`,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setTestimonials", response.data);
  },
  saveWorkItemImage: async ({ commit }, workItem) => {
    if (workItem.image) {
      let file = workItem.image.file;
      const metadata = {
        contentType: file.type,
      };
      let imageFile = await files
        .child(
          `workItemImages/newSaveFormat/${workItem.business_id}_${Math.floor(
            Math.random() * 1000000
          )}`
        )
        .put(file, metadata);
      let downloadUrl = await imageFile.ref.getDownloadURL();
      return downloadUrl;
    }
  },
  createLogin: async ({ commit, dispatch }, business) => {
    if (business.uid) {
      dispatch("notification/alert", "Business already has a ");
    }
  },
  uploadFile: async ({ commit }, fileData) => {
    let imageFile = await files
      .child(`promotionFiles/${fileData.meta.name}`)
      .put(fileData.data);
    let downloadUrl = await imageFile.ref.getDownloadURL();
    return downloadUrl;
  },
  createImpactReport: async ({ commit, rootState }, data) => {
    let business = await axios.post(
      `${rootState.axios.API}impactBusiness/createImpactBusinessFromSupplier`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    return business.data[0];
  },
};
